var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 8.89041L12.7337 15.8352C13.5371 16.3976 13.9388 16.6788 14.3757 16.7877C14.7616 16.8839 15.1653 16.8839 15.5513 16.7877C15.9882 16.6788 16.3899 16.3976 17.1933 15.8352L27.1145 8.89041M8.64497 24.6867H21.282C23.3235 24.6867 24.3443 24.6867 25.1241 24.2894C25.81 23.9399 26.3677 23.3822 26.7171 22.6963C27.1145 21.9165 27.1145 20.8958 27.1145 18.8542V11.0776C27.1145 9.03603 27.1145 8.01525 26.7171 7.23548C26.3677 6.54958 25.81 5.99192 25.1241 5.64243C24.3443 5.24512 23.3235 5.24512 21.282 5.24512H8.64497C6.60341 5.24512 5.58264 5.24512 4.80287 5.64243C4.11696 5.99192 3.5593 6.54958 3.20981 7.23548C2.8125 8.01525 2.8125 9.03603 2.8125 11.0776V18.8542C2.8125 20.8958 2.8125 21.9165 3.20981 22.6963C3.5593 23.3822 4.11696 23.9399 4.80287 24.2894C5.58264 24.6867 6.60341 24.6867 8.64497 24.6867Z",
    stroke: "#F5F5F5",
    strokeWidth: 2.4302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.84a2ddb0fe06727a1f935f19cca94c35.svg";
export { ForwardRef as ReactComponent };